var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotsThree({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 9.125C10.4832 9.125 10.875 9.51675 10.875 10C10.875 10.4832 10.4832 10.875 10 10.875C9.51675 10.875 9.125 10.4832 9.125 10C9.125 9.51675 9.51675 9.125 10 9.125Z",
    fill: "#343A40",
    stroke: "#808191",
    strokeWidth: 0.125
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 4.125C10.4832 4.125 10.875 4.51675 10.875 5C10.875 5.48325 10.4832 5.875 10 5.875C9.51675 5.875 9.125 5.48325 9.125 5C9.125 4.51675 9.51675 4.125 10 4.125Z",
    fill: "#343A40",
    stroke: "#808191",
    strokeWidth: 0.125
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9375 15C10.9375 14.4822 10.5178 14.0625 10 14.0625C9.48223 14.0625 9.0625 14.4822 9.0625 15C9.0625 15.5178 9.48223 15.9375 10 15.9375C10.5178 15.9375 10.9375 15.5178 10.9375 15Z",
    fill: "#343A40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsThree);
export default __webpack_public_path__ + "static/media/DotsThree.4d7b51f65dfb8130533986a1d737c29f.svg";
export { ForwardRef as ReactComponent };